import { useMutation, useQuery, useQueryClient } from "react-query";
import clientApi from "./client";
import { blockCard, debitCard, fundAccount, newCard } from "./routes";

// ---------- USERS DEBIT CARD -----------

export const fetchDebitCards = async () => {
  const { data } = await clientApi.get(debitCard);
  return data;
};

export const useGetUsersDebitCard = () => {
  return useQuery("users-debit-cards", fetchDebitCards);
};

// ---------- USERS GET NEW CARD -----------

export const requestNewCard = async (currency) => {
  const { data } = await clientApi.get(newCard(currency));
  return data;
};

// export const useGetUsersNewCard = (currency) => {
//   return useQuery(["get-new-cards", currency], () => requestNewCard(currency));
// };



// ---------- BLOCK USERS CARD -----------

export const blockUsersCard = async (cardId) => {
  const { data } = await clientApi.get(blockCard(cardId));
  return data;
};

// export const useBlockUsersCardHandler = (cardId) => {
//   return useQuery(["block-users-card", cardId], () => blockUsersCard(cardId));
// };

// ---------- FUND USERS CARD -----------

export const fundUserAccount = async (cardId, amount) => {
  const { data } = await clientApi.get(fundAccount(cardId, amount));
  return data;
};

